import { useMutation, useQuery } from '@tanstack/react-query';

import { useDismissGuidanceOptions } from '../api/practice-member.mutations';
import { preferencesOptions } from '../api/practice-member.queries';

export function useGuidance() {
    const { data, isPending } = useQuery(preferencesOptions());
    const { mutate } = useMutation(useDismissGuidanceOptions());

    const activeKeys: string[] = data?.guidance?.keys ?? [];
    const shouldShow = (key: string) => !isPending && activeKeys.includes(key);

    return {
        shouldShow,
        dismiss: (key: string) => mutate(key),
    };
}
